import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, InputLabel, Select, Typography, FormControl, MenuItem } from '@material-ui/core'
import useStyles from './style'
import CustomGraphs from './CustomGraphs'
import VppMapping from './constants'

const ForeCastGraphsDashboard = () => {
  const classes = useStyles()
  const [ granularity, setGranularity ] = useState("15mins")
  const [ duration, setDuration ] = useState("24H")
  const [site_ids, setSiteIds] = useState([])
  const [durationList, setDurationList] = useState(["3H","6H","12H","24H"])
  const granularityList = ['15mins']
  const [vppId, setVppId] = useState('')

  const vppList = ['vpp1-1000 sites', 'vpp2-750 sites', 'vpp3-250 sites', 'vpp4-25 sites', 'vpp5-1 intg site', 'vpp6-1 stage site']

  useEffect(() => {
    if (vppId !== ''){
      let id = vppId.split('-')[0]
      setSiteIds(VppMapping[id] || [])
    }
  }, [vppId])

  return (
    <>
      <Breadcrumb value={[{ 'Dashboard': '/dashboard' }, { 'Forecast Graphs': '/dashboard/forecast-graphs' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>VPP Power Forecast </Typography>
        <Box className={classes.subHeadingWrapper}>
          <FormControl >
            <InputLabel id="vpp-label" >Select Vpp Id</InputLabel>
            <Select
              labelId="vpp-label"
              id="vpp"
              classes={{ root: classes.selectRoot }}
              value={vppId}
              onChange={(e) => setVppId(e.target.value)}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }}
            >
              {vppList.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
            </Select>
          </FormControl>
          <Box width="20px"></Box>
          <FormControl >
            <InputLabel id="granularity-label" >Granularity</InputLabel>
            <Select
              labelId="granularity-label"
              id="granularity"
              classes={{ root: classes.selectRoot }}
              value={granularity}
              onChange={(e) => setGranularity(e.target.value)}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }}
            >
                {granularityList.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
            </Select>
          </FormControl>
          <Box width="20px"></Box>
          <FormControl >
            <InputLabel id="duration-label" >Duration</InputLabel>
            <Select
              labelId="duration-label"
              id="duration"
              value={duration}
              classes={{ root: classes.selectRoot }}
              onChange={(e) => setDuration(e.target.value)}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250, 
                    width: 100
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }}
            >
                {durationList.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box style={{display: 'flex'}}>
        <CustomGraphs duration={duration} setDuration={setDuration} granularity={granularity} setGranularity={setGranularity} site_ids={site_ids} />
      </Box>
    </>
  )
}

export default ForeCastGraphsDashboard